import { __awaiter } from "tslib";
import { isNullOrUndefined } from '@as-react/common-utils';
import { DELAY } from '../constants/GeneralConstants';
export const removeAttributeFromObject = (sourceObject, attributeToRemove) => Object.keys(sourceObject)
    .filter(attribute => attribute !== attributeToRemove)
    .reduce((result, current) => {
    result[current] = sourceObject[current];
    return result;
}, {});
export const compareArraysOfObjectsAndReturnDuplicates = (arrayA, arrayB, keyToCompare) => {
    let newArray = [];
    if (!isNullOrUndefined(arrayA) && !isNullOrUndefined(arrayB) && !isNullOrUndefined(keyToCompare)) {
        const keys = arrayA.map(obj => obj[keyToCompare]);
        newArray = arrayB.filter(obj => keys.indexOf(obj[keyToCompare]) > -1);
    }
    return newArray;
};
export const compareArraysOfObjectsAndReturnUniques = (arrayA, arrayB, keyToCompare) => {
    let newArray = [];
    if (!isNullOrUndefined(arrayA) && !isNullOrUndefined(arrayB) && !isNullOrUndefined(keyToCompare)) {
        const keys = arrayA.map(obj => obj[keyToCompare]);
        newArray = arrayB.filter(obj => keys.indexOf(obj[keyToCompare]) === -1);
    }
    return newArray;
};
export const mimicDelay = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (delay = DELAY.DELAY_500) { return yield new Promise(r => setTimeout(r, delay)); });
